/**
 * Puente entre la capa HTTP y el store. El store lo configura al arrancar (store/index.ts).
 * Evita el import circular client ↔ store y permite probar el cliente con un puente falso.
 */
export interface ApiBridge {
  getAccessToken(): string | null;
  /** Renueva la sesión (refresh token). Devuelve el nuevo access token o null si no se pudo. */
  refreshSession(): Promise<string | null>;
  /** La sesión murió (refresh inválido/reutilizado). No redirige: la app funciona sin cuenta. */
  onSessionLost(): void;
  /** 5xx en cualquier llamada (para avisar al usuario, deduplicado por el implementador). */
  onServerError?(status: number): void;
  /** Cambios del estado de conectividad con la API (true = respondió; false = sin red). */
  onReachability?(reachable: boolean): void;
}

const noop: ApiBridge = {
  getAccessToken: () => null,
  refreshSession: async () => null,
  onSessionLost: () => undefined,
};

let current: ApiBridge = noop;

export const configureApiBridge = (bridge: ApiBridge): void => {
  current = bridge;
};
export const getApiBridge = (): ApiBridge => current;
